import React, { useEffect } from 'react';
// @ts-ignore
import styles from './PlanTimelineItem.module.scss';
import { joinClasses } from '../../../Utils/className.util';
import { HealthPlanTimelineItem } from '../../../Models/HealthPlan/HealthPlanTimelineItem';
import { useAppContext } from '../../../Services/AppContext';
import NetteApiClient from '../../../Services/NetteApiClient';
import { useState } from 'react';
import AppointmentModal from '../Appointment/AppointmentModal';
import HealthPlanOtherConsultationsModal from '../../../Modules/HealthPlan/Components/HealthPlanOtherConsultations/HealthPlanOtherConsultationsModal';
import { useHealthPlanContext } from '../../../Services/HealthPlanContext';
import HealthPlanEducationMaterialsModal from '../../../Modules/HealthPlan/Components/HealthPlanEducationMaterials/HealthPlanEducationMaterialsModal';
import HealthPlanMonitoringModal from '../../../Modules/HealthPlan/Components/HealthPlanMonitoring/HealthPlanMonitoringModal';
import HealthPlanDiagnosticImagingModal from '../../../Modules/HealthPlan/Components/HealthPlanDiagnosticImaging/HealthPlanDiagnosticImagingModal';
import HealthPlanVaccinationModal from '../../../Modules/HealthPlan/Components/HealthPlanVaccination/HealthPlanVaccinationModal';
import HealthPlanLaboratoryExamModal from '../../../Modules/HealthPlan/Components/HealthPlanLaboratoryExam/HealthPlanLaboratoryExamModal';
import HealthPlanElectronicPrescriptionModal from '../../../Modules/HealthPlan/Components/HealthPlanElectronicPrescription/HealthPlanElectronicPrescriptionModal';
import HealthPlanMedicalReportModal from '../../../Modules/HealthPlan/Components/HealthPlanMedicalReport/HealthPlanMedicalReportModal';
import useWorkplaceRole from '../../../Modules/Workplace/Hooks/useWorkplaceRole';

interface PlanTimelineItem {
	item: HealthPlanTimelineItem;
	patientId: string;
	allowEdit?: boolean;
	workplaceId: string;
	reloadData?: any;
}

export default function PlanTimelineItem(props: PlanTimelineItem) {
	const { item, patientId, workplaceId, reloadData, allowEdit = true } = props;
	const { openItemModal, userData } = useAppContext();
	const { setActiveHealthPlanUserItem } = useHealthPlanContext();
	const { isDoctor } = useWorkplaceRole({ userId: userData?.id, workplaceId });
	const { title } = item;
	const { doctorStatus, status, custom } = item.extra;
	const [disabled, setDisabled] = useState(!allowEdit);
	const [currentStatus, setCurrentStatus] = useState(doctorStatus ?? status);

	const [modalOpened, setModalOpened] = useState({
		appointment: false,
		medicalEvaluation: false,
		otherConsultation: false,
		laboratoryExamination: false,
		educationMaterial: false,
		monitoring: false,
		diagnosticImaging: false,
		vaccination: false,
		electronicPrescription: false,
	});

	useEffect(() => {
		// @ts-ignore
		$('[data-toggle="tooltip"]').tooltip();
		const lStatus = item.extra?.doctorStatus ?? item.extra?.status;
		if (
			lStatus === 'cantFillNow' ||
			(lStatus === 'completed' && item.type !== 'monitoring')
		) {
			setDisabled(true);
		}
	}, []);

	useEffect(() => {
		setCurrentStatus(doctorStatus ?? status);
	}, [doctorStatus, status]);

	const handleClick = () => {
		if (disabled) {
			return;
		}

		setActiveHealthPlanUserItem(item);
		switch (item.type) {
			case 'appointment':
			case 'medicalEvaluation':
			case 'otherConsultation':
			case 'laboratoryExamination':
			case 'educationMaterial':
			case 'monitoring':
			case 'diagnosticImaging':
			case 'vaccination':
			case 'electronicPrescription':
				handleOpenModal(item.type);
				break;
			default:
				NetteApiClient.get(openItemModal.replace('__ID__', item.id));
				break;
		}
	};

	const handleOpenModal = (key: string) => {
		setModalOpened(prevValue => {
			return {
				...prevValue,
				[key]: true,
			};
		});
	};

	const handleCloseModal = (key: string) => {
		setModalOpened(prevValue => {
			return {
				...prevValue,
				[key]: false,
			};
		});
		reloadData?.();
	};

	return (
		<>
			{!custom ? (
				<div
					className={joinClasses([
						styles.wrapper,
						styles[currentStatus],
						disabled && styles.disabled,
					])}
					data-toggle='tooltip'
					data-placement='top'
					title={title}
					onClick={handleClick}
				/>
			) : (
				<div
					className={joinClasses([
						styles.wrapper,
						styles[currentStatus],
						styles.extra,
						disabled && styles.disabled,
					])}
					data-toggle='tooltip'
					data-placement='top'
					title={title}
					onClick={handleClick}>
					Extra
				</div>
			)}
			{item.type === 'appointment' && (
				<AppointmentModal
					opened={modalOpened.appointment}
					onClose={() => handleCloseModal(item.type)}
					patientId={patientId}
					healthPlanUserItemId={item.id}
					workplaceId={workplaceId}
					allowPickMeetingType={true}
					eventId={item.extra?.eventId}
				/>
			)}
			{item.type === 'medicalEvaluation' && (
				<HealthPlanMedicalReportModal
					patientId={patientId}
					workplaceId={workplaceId}
					opened={modalOpened.medicalEvaluation}
					onClose={() => handleCloseModal(item.type)}
				/>
			)}
			{item.type === 'otherConsultation' && (
				<HealthPlanOtherConsultationsModal
					opened={modalOpened.otherConsultation}
					onClose={() => handleCloseModal(item.type)}
				/>
			)}
			{item.type === 'laboratoryExamination' && (
				<HealthPlanLaboratoryExamModal
					opened={modalOpened.laboratoryExamination}
					onClose={() => handleCloseModal(item.type)}
				/>
			)}
			{item.type === 'educationMaterial' && (
				<HealthPlanEducationMaterialsModal
					opened={modalOpened.educationMaterial}
					onClose={() => handleCloseModal(item.type)}
					patientId={patientId}
				/>
			)}
			{item.type === 'monitoring' && (
				<HealthPlanMonitoringModal
					opened={modalOpened.monitoring}
					onClose={() => handleCloseModal(item.type)}
				/>
			)}
			{item.type === 'diagnosticImaging' && (
				<HealthPlanDiagnosticImagingModal
					opened={modalOpened.diagnosticImaging}
					onClose={() => handleCloseModal(item.type)}
				/>
			)}
			{item.type === 'vaccination' && (
				<HealthPlanVaccinationModal
					opened={modalOpened.vaccination}
					onClose={() => handleCloseModal(item.type)}
				/>
			)}
			{item.type === 'electronicPrescription' && (
				<HealthPlanElectronicPrescriptionModal
					opened={modalOpened.electronicPrescription}
					onClose={() => handleCloseModal(item.type)}
					patientId={patientId}
					defaultValues={item.extra?.data}
				/>
			)}
		</>
	);
}
